import { Box } from "@mui/material";
import { NavScrollPill } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/NavScrollPill";
import { useNavScrollPill } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/useNavScrollPill";

interface NavScrollPillWrapperProps {
  children: React.ReactNode;
  scrollContainerRef: React.RefObject<HTMLDivElement>;
}

export function NavScrollPillWrapper(props: NavScrollPillWrapperProps) {
  const { children, scrollContainerRef } = props;

  const { direction, count, scrollToItem } = useNavScrollPill(scrollContainerRef);

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      {children}
      {direction !== null && (
        <NavScrollPill direction={direction} count={count} onClick={scrollToItem} />
      )}
    </Box>
  );
}
